import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL_All } from '../api';
import axiosInstance from '../axiosInstance';
import AdminLayout from '../components/AdminLayout';
import { toast } from "react-toastify";
import { fetchSettingsPermissions } from "../libs/customerCreatePermission";


const SETTING_TITLES = { '1': 'Lines', '2': 'Đơn vị tính', '3': 'Danh mục', '4': 'Đối soát' };

const ParameterPage = () => {

  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('');
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const key = searchParams.get('key');
  const [model, setModel] = useState({});
  const [settingsPerm, setSettingsPerm] = useState({
    loaded: false,
    canView: false,
    canEdit: false,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchSettingsPermissions(axiosInstance);
      if (cancelled) return;
      setSettingsPerm({
        loaded: true,
        canView: Boolean(p?.canView),
        canEdit: Boolean(p?.canEdit),
      });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!settingsPerm.loaded || !settingsPerm.canView) return;
    const fetchPageContents = async () => {
      try {
        var requestApi = `/api/model-details/by-model/${key}`;
        const response = await axiosInstance.get(requestApi);
        //console.log(response.data);
        setItems(response.data);

        setTitle(SETTING_TITLES[key] || 'Thiết lập');

      } catch (error) {
        console.error("Error fetching :", error);
      }
    };
    if (key === "4") {
      fetchOneRecord();
    }
    fetchPageContents();
  }, [key, settingsPerm.loaded, settingsPerm.canView]);

  const fetchOneRecord = async () => {
    try {
      var requestApi = `/api/import-orders/getSetting`;
      const response = await axiosInstance.get(requestApi);
      setModel(response.data.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleChangeValue = async (e) => {
    if (!settingsPerm.canEdit) {
      toast.warning("Bạn không có quyền cập nhật.");
      return;
    }
    var dataModel = { ...model, invoiceAuto: e.target.checked };
    setModel(dataModel);
    await saveSetting(dataModel);
  };


  const saveSetting = async (dataModel) => {
    try {
      var requestApi = `/api/import-orders/saveSetting`;
      const response = await axiosInstance.post(requestApi, dataModel);
      if (!response.data.success) {
        toast.error(response.data.message);
        return;
      }

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.message);
      console.error("Error fetching :", error);
    }
  };

  return (
    <div>
      <AdminLayout>
        {settingsPerm.loaded && !settingsPerm.canView ? (
          <div className="container-fluid p-3 p-md-4">
            <div className="alert alert-warning mb-0">Bạn không có quyền truy cập màn hình này.</div>
          </div>
        ) : (
        <>
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12 ">
              <div className="x_panel">
                <div className="x_title">
                  <h2 className="fw-bold">{title}</h2>
                  <ul className="nav navbar-right panel_toolbox">
                  </ul>
                  <div className="clearfix"></div>
                </div>
                <div className="x_content calc-200 table-normal">
                  <form id="form_colors" className="" action="" method="post" noValidate>
                    <div className="table-s ">
                      <table>
                        <tbody>
                          <tr>
                            <th width="50px">STT</th>
                            <th>Tên</th>
                            <th>Notes</th>
                          </tr>
                          {items.map((item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td className="cell-normal"><span>{item.name}</span></td>
                              <td>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                  </form>
                  {key === "4" && (
                    <div className="row">
                      <div className="col-6 col-md-6 th filter-check pt-5">
                        <span className=""><input type="checkbox" checked={model.invoiceAuto} disabled={!settingsPerm.canEdit} onChange={(e) => handleChangeValue(e)} /></span>
                        <label className="form-check-label">Tự động tạo đối soát vào 2h sáng chủ nhật</label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>


          </div>
        </div>
        <footer className="d-none"> </footer>
        </>
        )}
      </AdminLayout>
    </div>
  );
};

export default ParameterPage;